import { Navigate, useLocation } from "react-router-dom";
import { canAccessPath, defaultPathForLevel } from "./access-level";
import { useAccessLevel } from "./AccessLevelContext";
import { AccessLevelModal } from "./AccessLevelModal";

/**
 * Profile gate:
 * - No selection → full access; modal on first visit (dismissible).
 * - With selection → restrict routes to the chosen level.
 * - "Changer de profil" reopens the modal without losing the current level.
 */
export function AccessGate({ children }: { readonly children: React.ReactNode }) {
  const { level, ready, promptOpen } = useAccessLevel();
  const location = useLocation();

  if (!ready) return null;

  const allowed = !level || canAccessPath(level, location.pathname);

  return (
    <>
      {allowed ? children : <Navigate to={defaultPathForLevel(level)} replace />}
      {promptOpen ? <AccessLevelModal /> : null}
    </>
  );
}
